/** @format */

import React from "react";
import { TUserTemporarySubshift } from "../../../redux-modules/declarations/maps/shifts";
import moment from "moment";
import { Dropdown, Menu, Modal } from "antd";
import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { UIText } from "../../ui/Text";
import { BaseColor } from "../../../theme/maps/Colors";

export const getUsersSubshiftListColumns = (onRemove: (user: TUserTemporarySubshift) => void, enrolledUsers: boolean) => {
    const columns =
        [
            {
                title: "Dipendente",
                dataIndex: "user",
                key: "user",
                showMobile: true,
                //@ts-ignore
                //eslint-disable-next-line react/display-name
                render: (row, user: TUserTemporarySubshift, index) => {
                    return <span>{user.surname} {user.name}</span>;
                },
                width: "33%"
            },
            {
                title: "Email",
                dataIndex: "email",
                key: "email",
                showMobile: true,
                //@ts-ignore
                //eslint-disable-next-line react/display-name
                render: (row, user: TUserTemporarySubshift, index) => {
                    return <span>{user.email}</span>;
                },
                width: "33%"
            },
            {
                title: "Data Richiesta Iscrizione",
                dataIndex: "date",
                key: "date",
                showMobile: true,
                //@ts-ignore
                //eslint-disable-next-line react/display-name
                render: (row, user: TUserTemporarySubshift, index) => {
                    return <span>{moment(user.date_enroll).format("DD/MM/YYYY HH:mm")}</span>;
                },
                width: "33%"
            },
        ];

        return [
            ...columns,
            enrolledUsers ? {
                title: "",
                dataIndex: "actions",
                key: "actions",
                showMobile: true,
                //@ts-ignore
                // eslint-disable-next-line react/display-name
                render: (text, event, index): JSX.Element => (
                    <ActionDropdown user={event} onRemove={onRemove}/>
                ),
            } : {}
        ];

};

const ActionDropdown = ({
  user,
  onRemove,
}: {
  user: TUserTemporarySubshift;
  onRemove: (user: TUserTemporarySubshift) => void;
}) => {

    const confirmRemove = () => {
        Modal.confirm({
            title: "Conferma rimozione",
            content: `Vuoi rimuovere ${user.name} ${user.surname}?`,
            okText: "Rimuovi",
            cancelText: "Annulla",
            okType: "danger",
            onOk: () => onRemove(user),
        });
    };

    const menu = (
        <Menu>
        <Menu.Item
            key="1"
            icon={<DeleteOutlined />}
            onClick={() => confirmRemove()}
        >
            Rimuovi
        </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
        <UIText css={"font-size: 24px; cursor: pointer;"} color={BaseColor}>
            <MoreOutlined />
        </UIText>
        </Dropdown>
    );
};